import {
  Address,
  CheUID,
  Identifiable,
  Industry,
  LegalEntityState,
  RevisionEmbed,
  ViewRevision,
} from '@mkp/shared/models';

export enum LegalEntityExternalSource {
  ChUidRegisterEntry = 'CH_UID_REGISTER_ENTRY',
  ChCommercialRegisterEntry = 'CH_COMMERCIAL_REGISTER_ENTRY',
  Network = 'NETWORK',
  Manual = 'MANUAL',
}

export interface LegalEntitySettings {
  staffingAgency: boolean;
}

export interface LegalEntity extends Identifiable, ViewRevision, RevisionEmbed {
  externalSource: LegalEntityExternalSource;
  externalId: CheUID;
  name: string;
  state: LegalEntityState;
  employeeCountFrom: number;
  employeeCountTo: number;
  industry: Industry['name'];
  claimed: boolean;
  industryId: string;
  address: Address;
  settings: LegalEntitySettings;
}

export type OrganisationEntry = Pick<LegalEntity, 'externalId' | 'name' | 'address' | 'state'> & {
  _type: 'organisationEntry';
};

export type CommercialRegisterEntry = Pick<
  LegalEntity,
  'externalId' | 'name' | 'address' | 'state' | 'employeeCountFrom' | 'employeeCountTo' | 'industry'
> & {
  _type: 'commercialRegisterEntry';
};

export interface LegalEntityCheUidPostBody {
  cheUid: LegalEntity['externalId'];
  industryId?: Industry['id'];
  employeeCountFrom?: number;
  employeeCountTo?: number;
}

export interface LegalEntityPostBody {
  externalSource: LegalEntity['externalSource'];
  externalId?: string;
  name: LegalEntity['name'];
  state: LegalEntity['state'];
  address: LegalEntity['address'];
  employeeCountFrom: LegalEntity['employeeCountFrom'];
  employeeCountTo: LegalEntity['employeeCountTo'];
  industryId: LegalEntity['industryId'];
}

export interface LegalEntityPatchBody {
  state: LegalEntity['state'];
  settings: LegalEntity['settings'];
}
